export default __webpack_public_path__ + "assets/images/f73642ee22aa8dade228a90bb1b40097.png";